import React from 'react';
import { MessageItem } from './MessageItem';
import { Message } from '@/services/conversations';

interface MessageListProps {
  messages: Message[];
  conversationId?: string;
}

export const MessageList: React.FC<MessageListProps> = ({ messages, conversationId }) => {
  const messagesEndRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className="space-y-6">
      {messages.map((message, index) => {
        // For assistant messages, find the previous user message
        let previousUserMessage: string | undefined;
        if (!message.is_user && index > 0) {
          for (let i = index - 1; i >= 0; i--) {
            if (messages[i].is_user) {
              previousUserMessage = messages[i].content;
              break;
            }
          }
        }
        
        return (
          <MessageItem 
            key={message.id} 
            message={message}
            conversationId={conversationId}
            previousUserMessage={previousUserMessage}
          />
        );
      })}
      <div ref={messagesEndRef} />
    </div>
  );
};
